import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnChanges, OnDestroy } from '@angular/core';

// The legacy TypeScript DOM library predates this native browser API.
declare class ResizeObserver {
    constructor(callback: () => void);
    observe(element: Element): void;
    disconnect(): void;
}

/** Fit a single-line card name down to a readable minimum; retain a tooltip for overflow. */
@Directive({ selector: '[fitnessFitBannerName]' })
export class FitBannerNameDirective implements AfterViewInit, OnChanges, OnDestroy {
    @Input() fitnessFitBannerName: string;
    @Input() fitName = true;
    private observer: ResizeObserver;
    private frame = 0;
    private ready = false;
    constructor(private element: ElementRef<HTMLElement>) {}
    ngAfterViewInit(): void {
        this.ready = true;
        if (typeof ResizeObserver !== 'undefined') {
            this.observer = new ResizeObserver(() => this.schedule());
            this.observer.observe(this.element.nativeElement);
        }
        this.schedule();
    }
    ngOnChanges(): void { this.schedule(); }
    @HostListener('window:resize') onResize(): void { this.schedule(); }
    private schedule(): void {
        if (!this.ready) { return; }
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
            const heading = this.element.nativeElement;
            heading.style.fontSize = '';
            if (!this.fitName || !heading.clientWidth) { return; }
            const maximum = parseFloat(getComputedStyle(heading).fontSize);
            const text = heading.querySelector('a') || heading;
            const width = text.scrollWidth;
            if (width > heading.clientWidth) {
                heading.style.fontSize = Math.max(12, Math.floor(maximum * heading.clientWidth / width)) + 'px';
            }
        });
    }
    ngOnDestroy(): void { this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
}
